import { FormattedMessage } from '@alltrails/shared/react-intl';
import Typography from '@alltrails/shared/denali/components/Typography';
import * as styles from './MedicalAdvisor.module.scss';
import barlett938Avif from './barlett-938w.avif';
import barlett938Webp from './barlett-938w.webp';
import barlett938Jpg from './barlett-938w.jpg';

// Desktop: https://www.figma.com/file/XrlDM2ZdWXmlnl7ZXUicGn/Press%2FAbout%2F404?node-id=1701%3A10862&t=GIO5RrtS36gjSh8J-4
// Mobile: https://www.figma.com/file/XrlDM2ZdWXmlnl7ZXUicGn/Press%2FAbout%2F404?node-id=1701%3A11369&t=GIO5RrtS36gjSh8J-4
export default function MedicalAdvisor() {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div>
          <picture>
            <source srcSet={barlett938Avif} type="image/avif" />
            <source srcSet={barlett938Webp} type="image/webp" />
            <img alt="" src={barlett938Jpg} className={styles.img} loading="lazy" />
          </picture>
        </div>
        <div className={styles.right}>
          <Typography component="div" variant="heading600">
            <FormattedMessage defaultMessage="Meet our medical advisor" />
          </Typography>
          <Typography className={styles.bio} component="div" variant="paragraph200">
            <FormattedMessage defaultMessage="Dr. Suzanne Bartlett Hackenmiller comes to us with a breadth of knowledge as our trusted medical advisor. Her personal experience with the healing effects of time outdoors has driven her to explore nature as a healing modality for her patients. Dr. Hackenmiller is an expert on the mental and physical health benefits of time outside, nature as medicine, forest bathing, and the intersection of fitness, health, wellness and the outdoors." />
          </Typography>
          <Typography component="div" variant="heading300">
            <FormattedMessage defaultMessage="Dr. Bartlett Hackenmiller" />
            <br />
            <span className={styles.title}>
              <FormattedMessage defaultMessage="Chief Medical Advisor" />
            </span>
          </Typography>
        </div>
      </div>
    </div>
  );
}
